export default __webpack_public_path__ + "static/media/upholstery.0c03b6de.png";